import logo from "../images/logo.jpg";

export default function Slider() {
  return (
    <div
      id="slide-hero"
      className="hero carousel slide"
      data-bs-ride="carousel"
    >
      <div className="mb-0 carousel-indicators">
        <button
          type="button"
          data-bs-target="#slide-hero"
          data-bs-slide-to="0"
          className="active"
          aria-current="true"
          aria-label="Slide 1"
        ></button>
        <button
          type="button"
          data-bs-target="#slide-hero"
          data-bs-slide-to="1"
          aria-label="Slide 2"
        ></button>
        <button
          type="button"
          data-bs-target="#slide-hero"
          data-bs-slide-to="2"
          aria-label="Slide 3"
        ></button>
      </div>
      <div className="carousel-inner">
        <div className="carousel-item active">
          <a href={logo} target="_blank">
            <img src={logo} />
          </a>
        </div>
        <div className="carousel-item">
          <a href={logo} target="_blank">
            <img src={logo} />
          </a>
        </div>
        <div className="carousel-item">
          <a href={logo} target="_blank">
            <img src={logo} />
          </a>
        </div>
      </div>
      <button
        className="px-5 carousel-control-prev"
        type="button"
        data-bs-target="#slide-hero"
        data-bs-slide="prev"
      >
        <span
          className="ms-5 carousel-control-prev-icon"
          aria-hidden="true"
        ></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="px-5 carousel-control-next"
        type="button"
        data-bs-target="#slide-hero"
        data-bs-slide="next"
      >
        <span
          className="ms-5 carousel-control-next-icon"
          aria-hidden="true"
        ></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
}
